import { useEffect } from "react";
import { styled } from "styled-components";

import { JoinUsUpgradeBanner } from "common/components";
import { CollectionCarousel } from "common/components/collectionCarousel/CollectionCarousel";
import { TopicPreviewCarousel } from "common/components/topicPreviewCarousel/TopicPreviewCarousel";
import { mediaStyles } from "common/styles";
import { useDispatch, useMemoisedSelector, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { fetchCollections } from "domains/collection/actions";
import { getFeaturedCollections, getListedCollections } from "domains/collection/selectors";
import { CollectionType } from "domains/collection/types/collectionType";
import { FeaturedCollection } from "domains/discover/components/FeaturedCollection";
import { FollowingTopicsSection } from "domains/landing/components/FollowingTopicsSection";
import { createTopicsSelector, getHighlightedTopicsIds } from "entities/topics/selectors";

const StyledCarouselContainer = styled.div`
  ${mediaStyles(({ spacing }) => `margin: 2rem ${spacing}rem 0;`)};
`;

const StyledJoinUsUpgradeBanner = styled(JoinUsUpgradeBanner)`
  ${mediaStyles(({ spacing }) => `margin: 2rem ${spacing}rem 0;`)};
`;

export const LandingPage = () => {
  const dispatch = useDispatch();
  const highlights = useMemoisedSelector(getHighlightedTopicsIds, createTopicsSelector);
  const featured = useSelector(getFeaturedCollections);
  const listed = useSelector(getListedCollections);
  const translate = useTranslate();

  useEffect(() => {
    dispatch(fetchCollections(CollectionType.Featured));
    dispatch(fetchCollections(CollectionType.Listed));
  }, [dispatch]);

  const topicPreviewHeader = translate("app.discover.topics.highlights.title");
  const collectionHeader = translate("app.discover.collections.title");

  return (
    <>
      <TopicPreviewCarousel topics={highlights} header={topicPreviewHeader} />
      <StyledJoinUsUpgradeBanner trackPage="Landing" />
      {featured.map((collection) => (
        <StyledCarouselContainer key={collection?.id}>
          <FeaturedCollection collection={collection} />
        </StyledCarouselContainer>
      ))}
      <FollowingTopicsSection />
      <CollectionCarousel collections={listed} header={collectionHeader} />
    </>
  );
};
